import React from "react";
import ReactExport from "react-export-excel";
import { currencyNumberFormat } from '../services/excelService';
import L from '../services/localizationService';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class OPNRExcelExport extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: props.data.data,
            project: props.data.project,
            totals: props.data.totals,
        }
    }

    render() {
        if (!this.props.data || this.props.data.loadingData) return null;

        let borderColor = 'ffffffff';

        let bottomBorder = { 
            bottom: { style: 'thick', color: borderColor},
        };

        let headerStyle = {alignment: { horizontal: 'center' }, font: {bold: true}};
        let dataSet = [
            {
                columnwidths: [12.29, 10, 10, 25, 25, 25, 12, 12, 25, 12, 12, 12, 12],
                columns: ['', '', '', '', '', '', '', '', '', '', '', '', ''],
                data: [
                    [
                        { value: 'PROJECT:', style: {font: {bold: true}} },
                        { value: this.state.project.ProjDesc },
                    ],
                    [
                        { value: 'PROJECT #:', style: {font: {bold: true}} },
                        { value: this.state.project.ProjNum.trim(), style: { numFmt: currencyNumberFormat }},
                        { value: '' },
                        { value: '' },
                        { value: '' },
                        { value: null },
                        { value: '' },
                        { value: '' },
                    ],
                    [
                        { value: 'PROJ. MGR.:', style: {font: {bold: true}, border: bottomBorder} },
                        { value: this.state.project.ProjMgr || '', style: { border: bottomBorder} },
                        { value: '', style: { border: bottomBorder} },
                        { value: '', style: { border: bottomBorder} },
                        { value: '', style: { border: bottomBorder} },
                        { value: '', style: { border: bottomBorder} },
                        { value: this.state.data.applyExchangeRate ? 'MXN RATE:' : '', style: {font: {bold: true}, alignment: { horizontal: 'right'}, border: bottomBorder} },
                        { value: this.state.data.applyExchangeRate ? this.props.data.exchangeRate : '', style: { border: bottomBorder} },
                        { value: '', style: { border: bottomBorder} },
                        { value: '', style: { border: bottomBorder} },
                        { value: '', style: { border: bottomBorder} },
                        { value: '', style: { border: bottomBorder} },
                        { value: '', style: { border: bottomBorder} },
                    ],
                    [
                        { value: 'COST CODE', style: headerStyle },
                        { value: 'PO', style: headerStyle },
                        { value: 'LINE', style: headerStyle },
                        { value: 'DESCRIPTION', style: headerStyle },
                        { value: 'VENDOR NAME', style: headerStyle },
                        { value: 'VENDOR PO', style: headerStyle },
                        { value: 'PO STATUS', style: headerStyle },
                        { value: 'ORDER DATE', style: headerStyle },
                        { value: 'ITEM', style: headerStyle },
                        { value: 'LINE STATUS', style: headerStyle },
                        { value: 'ORDERED', style: headerStyle },
                        { value: 'RECEIVED', style: headerStyle },
                        { value: 'OPNR', style: headerStyle },
                    ],
                ]
            }
        ];

        let lines = [];
        this.state.data.forEach((group) => {
            group.items.forEach((item) => {
                let values = [];

                values.push({ value: L.trimmedString(item.CostCode) });
                values.push({ value: L.trimmedString(item.PoNum) });
                values.push({ value: L.trimmedString(item.PoLine) });
                values.push({ value: L.trimmedString(item.Description) });
                values.push({ value: L.trimmedString(item.VenadrName) });
                values.push({ value: L.trimmedString(item.PoVendorPo) });
                values.push({ value: L.poStatToDesc(item.PoStat) });
                values.push({ value: L.sytelineDateToMoment(item.PoOrderDate).format('L') });
                values.push({ value: L.trimmedString(item.Item) });
                values.push({ value: L.trimmedString(item.DerStatFormatted) });
                values.push({ value: L.toExcelCurrencyString(item.DerExtPlanCostConvExc), style: { numFmt: currencyNumberFormat }});
                values.push({ value: L.toExcelCurrencyString(item.DerTotalRcvdCostExc), style: { numFmt: currencyNumberFormat }});
                values.push({ value: L.toExcelCurrencyString(item.opnr), style: { numFmt: currencyNumberFormat }});

                lines.push(values)
            })
        })

        let totalsLine = [];

        totalsLine.push({ value: '' });
        totalsLine.push({ value: '' });
        totalsLine.push({ value: '' });
        totalsLine.push({ value: '' });
        totalsLine.push({ value: '' });
        totalsLine.push({ value: '' });
        totalsLine.push({ value: '' });
        totalsLine.push({ value: '' });
        totalsLine.push({ value: '' });
        totalsLine.push({ value: '' });
        totalsLine.push({ value: '' });
        totalsLine.push({ value: '' });
        totalsLine.push({ value: L.toExcelCurrencyString(this.state.totals.opnr), style: { numFmt: currencyNumberFormat, font: {bold: true} }});

        lines.push(totalsLine)

        dataSet[0].data.push(...lines);

        return (
            <ExcelFile hideElement filename="OPNR Dashboard">
                <ExcelSheet dataSet={dataSet} name="OPNR" scale="68" orientation="landscape" />
            </ExcelFile>
        );
    }
}

export default OPNRExcelExport;
